import React from 'react';
import { Box, Accordion } from '@kohler-dsm-library/kohler-core';
import { AccordionContent } from './AccordionContent';

export default function AccordionGroup({ items = [] }) {
  const MAX_ITEMS = 5;
  return (
    <Box>
      {items.map((item, index) => (
        <Accordion key={index} title={{ text: item.title }} divider={true} size="medium">
          <AccordionContent html={item.detail} maxItems={MAX_ITEMS} />
        </Accordion>
      ))}
    </Box>
  );
}
